const menu = {
  state: {
    gengoList: [], // 元号リスト情報
    gengoYear: 0 // 令和（最新元号の元年）
  },
  mutations: {
    // 元号設定
    SET_GENGOLIST: (state, list) => {
      state.gengoList = list
    },
    // 年設定
    SET_GENGOYEAR: (state, year) => {
      state.gengoYear = year
    }
  }
}

export default menu